import type { ConnectionsData } from '@/shared/types/workspace';

export type Agent = 'claude-code' | 'codex';
export type FirstRunPhase = 'choose' | 'connect' | 'test';

export const AGENT_NAMES: Record<Agent, string> = { 'claude-code': 'Claude Code', codex: 'Codex' };

/** The agent that already works, if any (Claude Code first, as the design lists it). */
export function connectedAgent(connections: ConnectionsData): Agent | null {
  if (connections.claudeCode.status === 'CONNECTED') return 'claude-code';
  if (connections.codex.status === 'CONNECTED') return 'codex';
  return null;
}

export function initialPhase(connections: ConnectionsData): FirstRunPhase {
  return connectedAgent(connections) ? 'test' : 'choose';
}

export const stepNumber = (phase: FirstRunPhase): 1 | 2 | 3 =>
  phase === 'choose' ? 1 : phase === 'connect' ? 2 : 3;

export type StepMark = 'current' | 'done' | 'next';

export function stepMark(step: 1 | 2 | 3, current: 1 | 2 | 3, isFinished: boolean): StepMark {
  if (current > step || (step === 3 && isFinished)) return 'done';
  return current === step ? 'current' : 'next';
}
